import ConsumerService from '../../../services/consumers.service';

export async function getConsumers(store) {
	const items = await ConsumerService().getConsumers();
	const state = store.state;
	store.setState({ ConsumerList: { ...state.ConsumerList, items } });
}

